import $ from 'jquery';

export function initRequestLogs() {
    // Handle Datatables Modal clicks globally
    $(document).on('click', '.btn-view-payload', function () {
        var reqId = $(this).attr('data-reqid');
        var payload = $(this).attr('data-payload');

        $('#modalReqId').text(reqId);
        $('#modalPayloadContent').text(payload);
        $('#payloadModal').modal('show');
    });
}
